import { useEffect, useState } from "react"
import { usePageNameContext } from "../../contexts/PageTitleContext";
import { CleanedUkMap } from "./CleanedUkMap";
import TestNewEbayTemplate from "./TestNewEbayTemplate";
import useReports from "../../data/useReports";
import Card from "../../components/shared/Card/Card";
import { ButtonInput } from "../../components/shared/Inputs/ButtonInput";
import { IReport } from "../../models/report/Report";


const selectedCounties = [
  "Aberdeenshire",
  "Cornwall",
  "Dorset",
  "Swansea",
];

export function Test() {
  const { setInfo } = usePageNameContext();
  const [selectedCounty, setSelectedCounty] = useState<string | null>(null);


  useEffect(() => {
    setInfo({
      name: "Test",
      desc: "If you don't think you should be here, you shouldn't be here.",
    });
  }, []);

  const handleOnClick = (title: string) => {
    console.log(title);
    setSelectedCounty(title);

  };

  return (
    <div className="mt-4 flex flex-col gap-y-36 pb-[80vh]">
      {/* <CleanedUkMap handleOnClick={handleOnClick} selectedCounties={selectedCounties} />

      <hr /> */}

      {/* <TestNewEbayTemplate /> */}


      {/* {reports.data && reports.data.data.map((report) => (
        <>
          <div className="flex justify-between items-center">

            <div className="flex items-center gap-4">
              {report?.allowDates && (
                <>
                  <div>
                    <label className="text-sm font-medium text-gray-500">
                      Start Date
                    </label>
                    <input
                      aria-label="Date from"
                      type="date"
                      value={startDate || ""}
                      // max={endDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      className="w-full py-1 px-1 mt-1 text-sm text-gray-900 border border-border"
                    />
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-500">
                      End Date
                    </label>
                    <input
                      aria-label="Date to"
                      type="date"
                      value={endDate || ""}
                      // min={startDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      className="w-full py-1 px-1 mt-1 text-sm text-gray-900 border border-border"
                    />
                  </div>
                </>
              )}
              <div className="mt-5">
                <ButtonInput label="Run Report" onClick={() => handleRunReport(report)} classes="" />
              </div>
            </div>

            <div className="flex items-center gap-4">
              <ButtonInput label="Download" disabled={!reportData} onClick={() => handleCsvDownload(reportData)} classes="" />
            </div>

          </div>

          <div>
            <Card>
              <DynamicTable data={reportData} />
            </Card>
          </div>
        </>
      ))} */}


    </div>
  )
}